define('views/modules/calendar/animated-session/exercise/lists/exercise-list-placeholder',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/lists/exercise-list-placeholder.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TExerciseListPlaceholder
) {

    var VExerciseListPlaceholder = Backbone.View.extend({
        template: TExerciseListPlaceholder,
        events: {
            'click .exercise-placeholder': 'onClick',
        },

        initialize: function(opt) {
            this.options = opt || {};
        },

        render: function() {
            var $html = Backbone.$(Mustache.render(this.template, Mustache.getContext()));

            this.$el.replaceWith($html);
            this.setElement($html);

            return this;
        },

        toggle: function(val) {
            this.$el.toggle(!val);
        },

        ////////////
        // events //
        ////////////
        onClick: function(e) {
            this.collection.trigger('list:addExercise');
        }

    });

    return VExerciseListPlaceholder;

});

